import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import "./navbar.css";
import logoh from "../../assets/logoh.png";

class Navbar extends Component {
  state = {
    userMenuOpen: false,
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
    document.addEventListener("keydown", this.handleEsc);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    document.removeEventListener("keydown", this.handleEsc);
  }

  handleEsc = (e) => {
    if (e.key === "Escape") this.setState({ userMenuOpen: false });
  };

  handleOutsideClick = (e) => {
    if (!this.userMenuRef) return;
    if (!this.userMenuRef.contains(e.target)) {
      this.setState({ userMenuOpen: false });
    }
  };

  toggleUserMenu = () => {
    this.setState((prev) => ({ userMenuOpen: !prev.userMenuOpen }));
  };

  goAccount = () => {
    this.setState({ userMenuOpen: false });
    this.props.history.push("/ventas");
  };

  logout = () => {
    this.setState({ userMenuOpen: false });

    localStorage.removeItem("sharem");
    localStorage.removeItem("datosm");
    localStorage.removeItem("user");

    this.props.history.push("/");
  };

  render() {
    const { userMenuOpen } = this.state;

    const test = JSON.parse(localStorage.getItem("sharem"));
    const userName = test.nombre ? test.nombre : "Usuario";

    const tabs = [
      { to: "/catalogos", label: "Catálogos" },
      { to: "/ventas", label: "Ventas" },
      { to: "/solicitudes", label: "Solicitudes" },
      { to: "/facturacion", label: "Facturación" },
    ];

    return (
      <header className="mm-nav">
        <div className="mm-nav__inner">
          {/* LEFT: LOGO */}
          <div className="mm-nav__left">
            <NavLink to="/ventas" className="mm-nav__brand" aria-label="Inicio">
              <img
                className="mm-nav__logo"
                src={logoh}
                alt="Morena Mia Beauty"
              />

            </NavLink>
          </div>

          {/* CENTER: TABS */}
          <nav className="mm-nav__tabs" aria-label="Secciones">
            {tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                className="mm-tab"
                activeClassName="mm-tab--active"
              >
                {t.label}
              </NavLink>
            ))}
          </nav>

          {/* RIGHT: USER MENU */}
          <div
            className="mm-nav__right"
            ref={(ref) => (this.userMenuRef = ref)}
          >
            <button
              type="button"
              className="mm-user"
              onClick={this.toggleUserMenu}
              aria-haspopup="menu"
              aria-expanded={userMenuOpen}
            >
              <span className="mm-user__name">{userName}</span>
              <span className={`mm-user__chev ${userMenuOpen ? "is-open" : ""}`}>
                ▾
              </span>
            </button>

            {userMenuOpen && (
              <div className="mm-menu" role="menu">
                <button className="mm-menu__item" onClick={this.goAccount}>
                  Cuenta
                </button>
                <button className="mm-menu__item mm-menu__item--danger" onClick={this.logout}>
                  Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(Navbar);
